var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "appfade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.appIsLoaded,
            expression: "appIsLoaded"
          }
        ],
        staticClass: "generic-page--template page-template"
      },
      [
        _c("div", { staticClass: "db relative center z-0 w-100 h-auto" }, [
          _c("div", { staticClass: "container-fluid" }, [
            _c(
              "section",
              { staticClass: "db relative center mw7 tc pt5 pb5" },
              [
                _c(
                  "h3",
                  { staticClass: "tc mv4 ttu is-bebas is-white page-title" },
                  [_vm._v(_vm._s(_vm.page.title))]
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "cms-content tl is-interstate-regular is-white",
                  domProps: { innerHTML: _vm._s(_vm.page.content) }
                })
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }